import { FC } from "react";

import { Drawer } from "antd";
import styled from "styled-components";

import UserInputForm from "components/forms-view/user-input-form";

import { useApplicationContext } from "contexts/app";

import { convertIntoFormQuestion, DraggableQuestion } from "utils/navirec-forms";

const StyledDrawer = styled(Drawer)`
  .ant-drawer-header {
    background: #fff;
  }
`;

const FormPreviewDrawer: FC<{
  isVisible: boolean;
  form: { name: string; description: string; url: string };
  questions: DraggableQuestion[];
  onCancel: () => void;
}> = ({ isVisible, form, questions, onCancel }) => {
  const { configuration } = useApplicationContext();

  return (
    <StyledDrawer
      style={{ background: "#F5F5F5" }}
      width={700}
      onClose={onCancel}
      open={isVisible}
      title={form.name}
      footer={null}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          background: "#F5F5F5",
        }}
      >
        <UserInputForm
          type="preview"
          questions={convertIntoFormQuestion(questions, form.name)}
          account={configuration?.account?.url}
          form={form}
        />
      </div>
    </StyledDrawer>
  );
};

export default FormPreviewDrawer;
